module.exports = __webpack_public_path__ + "img/p2M.e94f50cb.png";